import { html, rune, View } from 'rune-ts';
import { makeEmptyScreenNavigate } from '../../../../shared/app/navigate';
import { dataStr } from '../../../../shared/util/dataStr';
import klass from './CreatorViewListItem.module.scss';
import { staticTypo, typo } from '../../../../shared/typography/typo';
import { isNil } from 'fxjs/es';
import { htmlIf } from '../../../../shared/util';
import { FeedShowInfoBoxView } from '../CurationListItem/FeedShowInfoBox';
import { MakeOptional } from '../../../../shared/type/types';
import { CreatorViewListItemData } from '../../../../features/CreatorView/type';
import { getResizedUrl } from '../../../../shared/util/image';

export interface CreatorViewListItemState {
  klass?: string;
  is_mobile?: boolean;
  thumbnail_type: 'short' | 'long';
  no_overlay?: boolean;
  is_admin_view?: boolean;
  outlink?: string;
  title_color?: string;
  sub_title_color?: string;
}

export type CreatorViewListItemOption = MakeOptional<
  CreatorViewListItemState,
  'outlink' | 'is_admin_view' | 'no_overlay'
>;

export class CreatorViewListItem extends View<CreatorViewListItemData> {
  state: CreatorViewListItemState;

  constructor(data: CreatorViewListItemData, option: CreatorViewListItemOption) {
    super(data, option);

    this.state = {
      klass: option.klass,
      is_mobile: option.is_mobile,
      thumbnail_type: option.thumbnail_type,
      no_overlay: option.no_overlay,
      is_admin_view: option.is_admin_view,
      outlink: option.outlink,
      title_color: option.title_color || 'inherit',
      sub_title_color: option.sub_title_color || 'inherit',
    };
  }

  getIsMobile(): boolean {
    const is_mobile = rune.getSharedData(this)?.is_mobile ?? this.state.is_mobile;
    if (isNil(is_mobile)) throw new Error('is_mobile is not set');
    return is_mobile;
  }

  override template() {
    const creator_view = this.data;
    const { thumbnail_type, no_overlay, is_admin_view, outlink, title_color, sub_title_color } = this.state;
    const link = outlink ?? `/${ET.lang}/@/creator_views/${creator_view.id}`;
    const is_mobile = this.getIsMobile();

    return html`<div
      class="${this.state.klass} ${klass.creator_view_list_item} ${htmlIf(
        klass.short,
        thumbnail_type == 'short',
      )}"
    >
      <a
        class="${klass.thumbnail_container}"
        href="${link}"
        data-post-message="${dataStr(makeEmptyScreenNavigate(link))}"
      >
        <img
          class="${klass.thumbnail}"
          src="${getResizedUrl({
            url: thumbnail_type === 'short' ? creator_view.mobile_thumbnail : creator_view.thumbnail,
            format: 'webp',
          })}"
          alt="thumbnail"
        />
        ${no_overlay
          ? ''
          : html`<div class="${klass.overlay}">
              <p class="${klass.numbering} ${staticTypo(is_mobile ? 'bebas_16_bold' : 'bebas_20_bold')}">
                VOL.${creator_view.numbering}
              </p>
              <p class="${klass.creator_name} ${staticTypo(is_mobile ? 'bebas_40_bold' : 'bebas_32_bold')}">
                ${creator_view.creator_name}
              </p>
            </div>`}
      </a>

      <a
        href="${link}"
        data-post-message="${dataStr(makeEmptyScreenNavigate(link))}"
        class="${klass.title} ${typo(is_mobile ? '16_bold' : '20_bold')}"
        style="color: ${title_color}"
        >${html.preventEscape(creator_view.title)}</a
      >
      <a href="${link}" class="${klass.sub_title} ${typo('14_medium')}" style="color: ${sub_title_color}"
        >${html.preventEscape(creator_view.sub_title)}</a
      >

      ${is_admin_view
        ? html`<div class="${klass.show_info_box}">${new FeedShowInfoBoxView(creator_view)}</div>`
        : ''}
    </div> `;
  }
}
